import { useState, useCallback, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { Button } from '../../../../common/Buttons';
import { ModalDialog } from '../../../../common/Dialogs';
import { useTrans } from '../../../../../services/i18n';
import { useAlertContext } from '../../../../../contexts/AlertContext';
import { SpacingContainer } from '../../../../common/Containers';
import { SelectField, TextField } from '../../../../common/Inputs';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '../../../../common/Typography';
import { USER_ROLES } from '../../../../../constants/user';
import { useForm } from '../../../../../hooks/useForm';
import { getInitialValues, useScheme } from './formik';
import { useApplication } from '../../../../../services/application';
import connect from '../connect';
import { AmplifyAuth } from '../../../../../services/amplifyAuth';

const formOptions = {
  validateOnMount: false,
  validateOnChange: false,
  validateOnBlur: false,
  enableReinitialize: true,
};

const FormAddUser = ({ updateInfoOrg, settings, authUser }) => {
  const { trans } = useTrans();
  const schema = useScheme();
  const { successAlert, errorAlert } = useAlertContext();
  const [isSend, setIsSend] = useState(false);
  const application = useApplication();
  const [open, setOpen] = useState(false);

  const validName = (name) => {
    const values = ['name', 'my', 'my organization', 'organization'];
    if (values.includes(name.trim().toLowerCase())) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (settings && settings.orgName && authUser && authUser.userName === settings.ownerId) {
      if (!validName(settings.orgName)) {
        setOpen(true);
      }
    }
  }, [settings, authUser]);

  const onSubmit = useCallback(
    async (values) => {
      if (!validName(values.orgName)) {
        errorAlert('Organization name is invalid');
        return;
      }

      setIsSend(true);
      application
        .call('organization.updateOrgInfo', { orgName: values.orgName, orgId: settings.id })
        .then(async (res) => {
          if (res) {
            successAlert('Organization name updated successfully');
            updateInfoOrg({ orgName: values.orgName });
            closeModal();
          }
        })
        .catch((e) => errorAlert(e.message))
        .finally(() => {
          setIsSend(false);
        });
    },
    [open, errorAlert, successAlert]
  );

  const { getFieldProps, handleSubmit, resetForm } = useForm(schema, getInitialValues({}), onSubmit, formOptions);

  const closeModal = () => {
    resetForm();
    setOpen(false);
  };

  return (
    <ModalDialog
      open={open}
      title={trans('change-your-organization-name')}
      onlyTitle={true}
      actions={
        <Grid container spacing={2} justifyContent="flex-end">
          {/* <Grid item>
            <Button variant="outlined" color="primary" disabled={isSend} onClick={closeModal}>
              {trans('cancel')}
            </Button>
          </Grid> */}
          <Grid item>
            <Button variant="contained" color="primary" disabled={isSend} pending={isSend} onClick={handleSubmit}>
              {trans('save')}
            </Button>
          </Grid>
        </Grid>
      }
    >
      <SpacingContainer px={2} py={3}>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} xs={12}>
            <TextField
              label={trans('organization-name')}
              placeholder={trans('required')}
              required
              maxLength={255}
              {...getFieldProps('orgName')}
            />
          </Grid>
        </Grid>
      </SpacingContainer>
    </ModalDialog>
  );
};

export default connect(FormAddUser);
